export const GOOGLE_ADDRESS_COMPONENT_EQUIVALENT = {
  CITY: 'locality',
  ZIP: 'postal_code',
  STATE: 'administrative_area_level_1'
};
